export default __webpack_public_path__ + "static/media/baccarat_banner.f2e55fa1.jpg";